var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 305,
    viewBox: "0 0 71 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.34447 33.6001H71V36.7447H-5.34447V33.6001Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.34466 0H43.7891V16.8171H-5.34466V0Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 45.9937H62.8154V63.5019H49.4694V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 68.0864H62.8154V85.5947H49.4694V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 90.168H62.8154V107.676H49.4694V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 112.249H62.8154V129.757H49.4694V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 134.341H62.8154V151.85H49.4694V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 156.434H62.8154V173.942H49.4694V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 178.504H62.8154V196.012H49.4694V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 200.596H62.8154V218.104H49.4694V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 222.689H62.8154V240.197H49.4694V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 244.771H62.8154V262.279H49.4694V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 266.852H62.8154V284.36H49.4694V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 288.944H62.8154V306.452H49.4694V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 45.9937H62.8154V63.5019H49.4694V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 68.0864H62.8154V85.5947H49.4694V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 90.168H62.8154V107.676H49.4694V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 112.249H62.8154V129.757H49.4694V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 134.341H62.8154V151.85H49.4694V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 156.434H62.8154V173.942H49.4694V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 178.504H62.8154V196.012H49.4694V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 200.596H62.8154V218.104H49.4694V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 222.689H62.8154V240.197H49.4694V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 244.771H62.8154V262.279H49.4694V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 266.852H62.8154V284.36H49.4694V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4694 288.944H62.8154V306.452H49.4694V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 45.9937H40.7153V63.5019H27.3693V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 68.0864H40.7153V85.5947H27.3693V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 90.168H40.7153V107.676H27.3693V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 112.249H40.7153V129.757H27.3693V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 134.341H40.7153V151.85H27.3693V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 156.434H40.7153V173.942H27.3693V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 178.504H40.7153V196.012H27.3693V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 200.596H40.7153V218.104H27.3693V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 222.689H40.7153V240.197H27.3693V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 244.771H40.7153V262.279H27.3693V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 266.852H40.7153V284.36H27.3693V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 288.944H40.7153V306.452H27.3693V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 45.9937H40.7153V63.5019H27.3693V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 68.0864H40.7153V85.5947H27.3693V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 90.168H40.7153V107.676H27.3693V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 112.249H40.7153V129.757H27.3693V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 134.341H40.7153V151.85H27.3693V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 156.434H40.7153V173.942H27.3693V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 178.504H40.7153V196.012H27.3693V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 200.596H40.7153V218.104H27.3693V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 222.689H40.7153V240.197H27.3693V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 244.771H40.7153V262.279H27.3693V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 266.852H40.7153V284.36H27.3693V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3693 288.944H40.7153V306.452H27.3693V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 45.9937H18.6025V63.5019H5.25649V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 68.0864H18.6025V85.5947H5.25649V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 90.168H18.6025V107.676H5.25649V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 112.249H18.6025V129.757H5.25649V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 134.341H18.6025V151.85H5.25649V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 156.434H18.6025V173.942H5.25649V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 178.504H18.6025V196.012H5.25649V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 200.596H18.6025V218.104H5.25649V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 222.689H18.6025V240.197H5.25649V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 244.771H18.6025V262.279H5.25649V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 266.852H18.6025V284.36H5.25649V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 288.944H18.6025V306.452H5.25649V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 45.9937H18.6025V63.5019H5.25649V45.9937Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 68.0864H18.6025V85.5947H5.25649V68.0864Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 90.168H18.6025V107.676H5.25649V90.168Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 112.249H18.6025V129.757H5.25649V112.249Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 134.341H18.6025V151.85H5.25649V134.341Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 156.434H18.6025V173.942H5.25649V156.434Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 178.504H18.6025V196.012H5.25649V178.504Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 200.596H18.6025V218.104H5.25649V200.596Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 222.689H18.6025V240.197H5.25649V222.689Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 244.771H18.6025V262.279H5.25649V244.771Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 266.852H18.6025V284.36H5.25649V266.852Z",
    fill: "white",
    fillOpacity: 0.25
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25649 288.944H18.6025V306.452H5.25649V288.944Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBuilding);
export default __webpack_public_path__ + "static/media/group-building.957db1e3ede2ca45201bb4c77700abb3.svg";
export { ForwardRef as ReactComponent };